import { action, computed, thunk } from 'easy-peasy'

import { FetchStatus } from '@/types'

import { CityModel, service } from '.'
import { AxiosError } from 'axios'

export const city: CityModel = {
	data: [],
	status: FetchStatus.IDLE,
	paginator: {
		current_page: 1,
		next_page: 0,
		per_page: 10,
		previous_page: 0,
		total_items: 0,
		total_pages: 1
	},
	error: '',

	/** Computed */
	loading: computed(state => state.status === FetchStatus.LOADING),
	loadingMore: computed(state => state.status === FetchStatus.FETCHING_MORE),
	loaded: computed(state => state.status === FetchStatus.LOADED),

	/** Action */
	setData: action((state, payload) => {
		state.data = payload
	}),
	addData: action((state, payload) => {
		state.data = [...state.data, ...payload]
	}),
	setPaginator: action((state, payload) => {
		state.paginator = payload
	}),
	setStatus: action((state, payload) => {
		state.status = payload
	}),
	setError: action((state, payload) => {
		state.error = payload
	}),

	/** Thunks */
	fetch: thunk(async (action, payload) => {
		try {
			action.setStatus(FetchStatus.LOADING)
			const res = await service.fetch(payload)
			action.setData(res.data)
			action.setPaginator(res.paginator)
			action.setStatus(FetchStatus.LOADED)
		} catch (e) {
			if (e instanceof AxiosError) {
				action.setStatus(FetchStatus.ERROR)
				action.setError(
					e?.response?.data?.message ||
						(navigator.onLine ? 'Server Error' : 'Network Error')
				)
			}
		} finally {
			setTimeout(() => {
				action.setError('')
			}, 1)
		}
	}),
	fetchMore: thunk(async (action, payload) => {
		try {
			action.setStatus(FetchStatus.FETCHING_MORE)
			const res = await service.fetch(payload)
			action.addData(res.data)
			action.setPaginator(res.paginator)
			action.setStatus(FetchStatus.LOADED)
			action.setError('')
		} catch (e) {
			if (e instanceof AxiosError) {
				action.setStatus(FetchStatus.ERROR)
				action.setError(
					e?.response?.data?.message ||
						(navigator.onLine ? 'Server Error' : 'Network Error')
				)
			}
		} finally {
			setTimeout(() => {
				action.setError('')
			}, 1)
		}
	})
}
